import React from 'react';
import ReactDOM from 'react-dom';

import { initialize as initializeLabels } from '@cm/new-shared-fe/services/labels';
import { initialize as initializeParameters } from '@cm/new-shared-fe/services/parameters';

import Application from './app.component';
import { initializeUserinfo } from './services/user.service';

(async () => {
  const domains = { cm: 'nl', mc: 'fr', 'ckk-mc': 'de' };
  // Retrieve language from domain (tridion) with fallback for index.html used on the container
  const language = domains[window.location.hostname.split('.').reverse()[1]] || detectLanguage();

  const data = await Promise.all([
    initializeLabels(['DIMONA'], language, '/dimona-app'),
    initializeParameters('DIMONA', language, '/dimona-app'),
    initializeUserinfo().catch(e => e),
  ]);

  const userInfo = data?.pop();

  // Get our shadow HOST
  const host = document.querySelector('#dimona-app');
  // Create a shadow root inside it
  const shadow = host.attachShadow({ mode: 'open' });
  // Create the element where we would render our app
  const renderIn = document.createElement('div');
  // Append the renderIn element inside the shadow
  shadow.appendChild(renderIn);
  // Now render the application in the slot
  ReactDOM.render(<Application user={userInfo instanceof Error ? {} : userInfo} error={userInfo instanceof Error ? userInfo : null} />, renderIn);
})();
